import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, FormControl, FormLabel, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { IconSettings } from "@tabler/icons";
import { ChangeEvent, FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { usePostBodyWithJwtMutation } from "src/redux/api/cabinet";
import { iLogout } from "src/redux/slices/app";
import { palette } from "src/theme/style/palette";
import { Alerting } from "src/views/components_cabinet/Alerting";
import Select, { SingleValue } from 'react-select';
import { currencyList } from "src/components/shared/constants/currencyList";
import { P2pAddReqviz } from "./P2pAddReqviz";

// const rows = [
//     { name: 'Тестовое имя', age: 25, email: 'test@example.com' },
//     { name: 'Тестовое имя', age: 25, email: 'test@example.com' },
// ];


const customStyles = {
    control: (base: any) => ({
        ...base,
        padding: '2px 6px',
        width: '100%',
        height: "94px",
        backgroundColor: "rgba(255, 255, 255, 0.2) !important",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        border: `1px solid ${palette.blue}`,
        borderRadius: '6px',
        '&:hover': {
            borderColor: palette.blue,
        },
    }),
    menu: (base: any) => ({
        ...base,
        borderRadius: '6px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    }),
    option: (base: any, state: any) => ({
        ...base,
        backgroundColor: state.isSelected ? palette.blue : base.backgroundColor,
        color: state.isSelected ? '#fff' : base.color,
        '&:hover': {
            backgroundColor: palette.blueLight,
            color: '#000',
        },
    }),
    placeholder: (base: any) => ({
        ...base,
        color: palette.blue,
    }),
};

interface CurrencyOption {
    label: string;
    value: string;
}

interface Requisite {
    bank: string;
    account: string;
    currency: string;
}

const defaultValue: Requisite = {
    bank: '',
    account: '',
    currency: '',
};

export const P2pReqvizTable = () => {
    const dispatch = useDispatch();
    const [getAlert, setgetAlert] = useState<{ type: number, msg: string } | undefined>(undefined);
    const [rowsArray, setRowsArray] = useState<any[] | undefined>(undefined);
    const [textError, setTextError] = useState<string | undefined>(undefined);
    const [selectedCurrency, setSelectedCurrency] = useState<SingleValue<CurrencyOption>>({ label: 'Выбрать', value: '' });

    const [reloadTableList, setReloadTableList] = useState<boolean>(false);

    const [editReqvizitData, setEditReqvizitData] = useState<any>(undefined); // данные выбранного строки для редактирования
    const [modalForEdit, setModalForEdit] = useState<boolean>(false);

    const [newRequisiteArray, setNewRequisiteArray] = useState<Requisite>({
        ...defaultValue,
        bank: editReqvizitData?.bank || '',
        account: editReqvizitData?.account || '',
        currency: editReqvizitData?.currency_id || '',
    });

    const reloadList = () => {
        setReloadTableList(!reloadTableList);
    }

    const openModalForEdit = (dataForEdit: any) => {
        setEditReqvizitData(dataForEdit);
        setModalForEdit(true);
    }

    const closeModalForEdit = () => {
        setModalForEdit(false);
        setEditReqvizitData(undefined);
        setNewRequisiteArray(defaultValue);
    }

    const updateRequisite = (data: any) => {
        setNewRequisiteArray(data);
    }

    const [getData, { isLoading, isError }] = usePostBodyWithJwtMutation();
    const getDataFunction = async (data: any = [], route = 'p2p-accounts') => {
        const jwt = localStorage.getItem('jwt');

        try {
            const payload = await getData({
                body: data,
                route,
                // route: 'p2p-account-add', // добавление
                jwt
            }).unwrap();
            setRowsArray(payload?.data || []);
            closeModalForEdit();
        } catch (error: any) {
            if (error.data?.message === 'Unauthenticated.') dispatch(iLogout());
            setgetAlert({ type: 2, msg: error.data.message });
            setTextError(error.data.message)
        }
    }

    const updateItemRequisite = (route = 'p2p-account-add') => {

        const data: any = {
            ...newRequisiteArray,
            account_id: editReqvizitData.id,
        };

        if (data?.bank?.length < 2) {
            setgetAlert({ type: 2, msg: "Введите название банка" });

            return;
        }

        if (data?.currency < 1) {
            setgetAlert({ type: 2, msg: "Выберите валюту" });

            return;
        }

        if (data?.account.length < 3) {
            setgetAlert({ type: 2, msg: "Введите описание реквизита" });

            return;
        }

        getDataFunction(data, route);
    }

    const updateNewRequisiteCurrency = (selectedOption: SingleValue<CurrencyOption>) => {
        const currency = selectedOption?.value || '';
        setSelectedCurrency(selectedOption);
        setNewRequisiteArray((prev: any) => ({
            ...prev,
            currency
        }));
    };

    useEffect(() => {
        setNewRequisiteArray({
            ...defaultValue,
            bank: editReqvizitData?.bank || '',
            account: editReqvizitData?.account || '',
            currency: editReqvizitData?.currency_id || '',
        });

        const currencyFromList = currencyList.find(
            (currency) => currency.value === editReqvizitData?.currency_id
        );

        const tar: CurrencyOption = {
            label: currencyFromList?.label || 'Выбрать',
            value: currencyFromList?.value || ''
        };

        updateNewRequisiteCurrency(tar);
    }, [editReqvizitData]);

    useEffect(() => {
        // getDataFunction({
        //     account: 'dddd',
        //     bank: 'dddd',
        //     currency: 'RUB',
        // }, 'p2p-account-add');

        // {account:"asdfdsf"account_id:167bank:"asdfasdf"currency:"RUB"} // изменение
        getDataFunction();
    }, [reloadTableList])

    return (
        <>
            {getAlert && <Alerting get={getAlert} />}

            {/* <pre>
                {JSON.stringify(rowsArray, null, 2)}
            </pre> */}

            <Box display='flex' justifyContent='space-between' alignItems='center' my={3}>
                <Typography variant="h6">
                    Таблица реквизитов
                </Typography>
                <P2pAddReqviz reloadList={reloadList} />
            </Box>

            <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <Typography variant="h6" component='h3'>
                                    <strong>№</strong>
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="h6" component='h3'>
                                    <strong>Банк</strong>
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="h6" component='h3'>
                                    <strong>Валюта</strong>
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="h6" component='h3'>
                                    <strong>Реквизит</strong>
                                </Typography>
                            </TableCell>
                            <TableCell>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isLoading ? (
                            <TableRow>
                                <TableCell colSpan={5}>
                                    <Box minHeight={360} display='flex' justifyContent='center' alignItems='center'>
                                        <CircularProgress />
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ) : isError ?
                            <TableRow>
                                <TableCell colSpan={5}>
                                    <Box minHeight={360} display='flex' justifyContent='center' alignItems='center'>
                                        <Typography variant="h6" textAlign='center' color='error'>
                                            {textError || 'Ошибка при загрузке'}
                                        </Typography>
                                    </Box>
                                </TableCell>
                            </TableRow> :
                            rowsArray && rowsArray?.length > 0 ? rowsArray.map((row, index) => (
                                <TableRow
                                    key={index}
                                    sx={{
                                        backgroundColor:
                                            index % 2 !== 0
                                                ? palette.blueLightTwo
                                                : 'inherit',
                                    }}
                                >
                                    <TableCell>
                                        <Typography variant="h6">
                                            {index + 1}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="h6">
                                            {row.bank}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="h6">
                                            {row.currency}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="h6">
                                            {row.account}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Box>
                                            <Button onClick={() => openModalForEdit(row)}>
                                                <IconSettings />
                                            </Button>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )) :
                                <TableRow>
                                    <TableCell colSpan={5}>
                                        <Box minHeight={360} display='flex' justifyContent='center' alignItems='center'>
                                            <Typography variant="h5" textAlign='center'>
                                                Реквизитов нет
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            {/* модалка */}
            <Dialog
                open={modalForEdit}
                maxWidth='lg'
                fullWidth
                onClose={closeModalForEdit}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >

                {/* <pre>
                        {JSON.stringify(editReqvizitData, null, 2)}
                    </pre> */}
                <DialogContent sx={{ position: 'relative' }}>
                    <Typography variant="h4" textAlign='start' sx={{ mb: 3 }}>Обновление</Typography>

                    {editReqvizitData &&
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: "center", minHeight: '300px' }}>
                            {/* <Typography variant="h6">Название банка: {updateRequisite.bank}</Typography>
                        <Typography variant="body1">Валюта: {updateRequisite.currency}</Typography>
                        <Typography variant="body1">Реквизит: {updateRequisite.requisite}</Typography> */}
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6} lg={4} display='flex'>

                                    <Box width="100%">
                                        <FormControl fullWidth>
                                            <FormLabel sx={{ mb: 1 }}>Название банка/Платёжной системы</FormLabel>
                                            <TextField
                                                variant="outlined"
                                                multiline
                                                rows={2} // Количество строк
                                                value={newRequisiteArray.bank}
                                                placeholder="Название банка или тип перевода"
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => updateRequisite({ ...newRequisiteArray, bank: e.target.value })}
                                                helperText={<Typography component="span" variant='body2'
                                                    sx={{ fontWeight: 600, color: (100 - newRequisiteArray.bank.length) < 5 ? palette.error : 'auto' }}
                                                >Осталось {100 - newRequisiteArray.bank.length} символов</Typography>}
                                            />
                                        </FormControl>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={6} lg={4} display='flex'>
                                    <Box width="100%">
                                        <FormControl fullWidth>
                                            <FormLabel sx={{ mb: 1 }}>Имя/Счет/Карта/Реквизиты/СБП/Телефон</FormLabel>
                                            <TextField
                                                variant="outlined"
                                                multiline
                                                rows={2} // Количество строк
                                                value={newRequisiteArray.account}
                                                placeholder="Опишите как вы хотите получить платёж"
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => updateRequisite({ ...newRequisiteArray, account: e.target.value })}
                                                helperText={<Typography component="span" variant='body2' sx={{ fontWeight: 600, color: (100 - newRequisiteArray.account.length) < 5 ? palette.error : 'auto' }}>Осталось {100 - newRequisiteArray.account.length} символов</Typography>}
                                            />
                                        </FormControl>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6} lg={4} display='flex'>
                                    <Box width="100%">
                                        <FormControl fullWidth>
                                            <FormLabel sx={{ mb: 1 }}>Выберите валюту для этих реквизитов.</FormLabel>
                                            <Select<CurrencyOption>
                                                value={selectedCurrency}
                                                onChange={updateNewRequisiteCurrency}
                                                options={currencyList}
                                                getOptionLabel={(e: CurrencyOption) => e.label}
                                                getOptionValue={(e: CurrencyOption) => e.value}
                                                placeholder="Выберите валюту"
                                                isSearchable={true}
                                                styles={{
                                                    ...customStyles,
                                                    menuPortal: (base: any) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                }}
                                                menuPortalTarget={document.body}
                                            />
                                        </FormControl>
                                    </Box>
                                </Grid>
                            </Grid>
                            {/* Здесь можно разместить форму для редактирования */}
                            <Box display='flex' justifyContent='center' alignItems='center' pt={5}>
                                <Button
                                    disabled={isLoading || newRequisiteArray.bank.length > 100 || newRequisiteArray.account.length > 100}
                                    variant='contained'
                                    onClick={() => updateItemRequisite()}
                                >
                                    Обновить данные
                                </Button>
                            </Box>

                            <Box display='flex' justifyContent='center' alignItems='center' pt={5}>
                                <Button disabled={isLoading} variant='outlined' color='error' sx={{ color: palette.error, border: `1px solid ${palette.error}` }} onClick={() => getDataFunction({
                                    del: true,
                                    account_id: editReqvizitData.id,
                                }, 'p2p-account-add')}>
                                    Удалить этот реквизит
                                </Button>
                            </Box>
                        </Box>
                    }

                </DialogContent>
                <DialogActions>
                    <Button onClick={closeModalForEdit}>Закрыть</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
